import { firebaseAuth } from "@lemonadetraining/web-shared";

// Sends the ID token in the URL; LT-751 replaces this with a one-time exchange code.
export async function openDashboard(page = "/dashboard") {
  const appUrl = process.env.REACT_APP_APP_URL || "http://localhost:3001";

  try {
    const currentUser = firebaseAuth.currentUser;
    if (currentUser) {
      const idToken = await currentUser.getIdToken();
      const url = new URL(`${appUrl}${page}`);
      url.searchParams.set("fromLogin", "true");
      url.searchParams.set("authToken", idToken);
      window.location.href = url.toString();
    } else {
      window.location.href = `${appUrl}${page}`;
    }
  } catch (error) {
    console.error("Error getting ID token:", error);
    window.location.href = `${appUrl}${page}`;
  }
}
